import React from "react";
import { webshopUserImageUrlCreator } from "../../lib/userImageUrlCreators";
export const defaultAssetResolver = {
    greenScreenBackgroundUrl: (uuid, effect = "original", rotation = 0) => `/system/gsbackground.php?uuid=${uuid}&rotation=${rotation}&effect=${effect}`,
    imageUrl: webshopUserImageUrlCreator,
};
export const AssetResolverContext = React.createContext(defaultAssetResolver);
export const useAssetResolver = () => React.useContext(AssetResolverContext);
export function AssetResolverProvider({ resolver, children, }) {
    return (React.createElement(AssetResolverContext.Provider, { value: resolver }, children));
}
